export const DomainStatus = {
  Unsupported: 'Unsupported',
  Pending: 'Pending',
  Authenticated: 'Authenticated',
  Unauthenticated: 'Unauthenticated',
};
